import { useState, useEffect, useCallback } from "react";
import { PageLayoutConfig } from "@/components/layout/index";

export const usePageLayout = (
  document: any, 
  onDocumentCreated: (id: string) => void, 
  onWidgetDataChange: (widgetId: string, glossaryItemId: string, data: Record<string, unknown>) => void
) => {
  const [pageLayoutConfig, setPageLayoutConfig] = useState<PageLayoutConfig>({
    title: document?.name || "Document",
    spacing: 32,
    padding: 60,
    rows: [],
  });

  const createDefaultLayout = useCallback((docName: string, docId: string): PageLayoutConfig => ({
    title: docName,
    spacing: 32,
    padding: 60,
    rows: [
      {
        id: "row-1",
        title: "Content",
        layoutConfig: {
          elements: [
            {
              id: "content-1",
              type: "stats-widget",
              props: {
                title: "Document Content",
                description: "Add your content here",
              },
            },
            {
              id: "blueprint-1",
              type: "document-blueprint-widget",
              props: {
                title: "Create New Document",
                description: "Use a blueprint to create a new document",
                onDocumentCreated,
                parentDocumentId: docId,
                widgetId: "blueprint-1",
                onWidgetDataChange,
              },
            },
          ],
          gap: 40,
          padding: 0,
        },
      },
    ],
  }), [onDocumentCreated, onWidgetDataChange]);

  useEffect(() => {
    if (document) {
      let layoutData = document.data as unknown as PageLayoutConfig;
      
      if (!layoutData || Object.keys(layoutData).length === 0 || !layoutData.rows) {
        layoutData = createDefaultLayout(document.name, document.id);
      } 

      setPageLayoutConfig(layoutData);
    }
  }, [document, createDefaultLayout]);

  return pageLayoutConfig;
};
